$(() => {
    if (!inIframe()) {
        $('html').removeClass('on-page-editor');
    }
});

function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}
